module.exports = __webpack_public_path__ + "static/img/btn_gfcz.a72b0b4.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/btn_gfcz.png
// module id = H5OK
// module chunks = 7